export const loadImages = () => {
  return new Promise((resolve) => {
    const images = {};
    let loadedCount = 0;
    const totalImages = 16; // Total number of images to load

    const checkAllLoaded = () => {
      loadedCount++;
      if (loadedCount === totalImages) {
        resolve(images);
      }
    };

    // Player image
    images.specky = new Image();
    images.specky.onload = checkAllLoaded;
    images.specky.src = '/images/specky.png';

    // Coin image
    images.coin = new Image();
    images.coin.onload = checkAllLoaded;
    images.coin.src = '/images/coin.png';

    // Boost rocket image
    images.boostRocket = new Image();
    images.boostRocket.onload = checkAllLoaded;
    images.boostRocket.src = '/images/boost-rocket.png';

    // Projectile image
    images.projectile = new Image();
    images.projectile.onload = checkAllLoaded;
    images.projectile.src = '/images/projectile.png';

    // Platform images
    images.platformSolid = new Image();
    images.platformSolid.onload = checkAllLoaded;
    images.platformSolid.src = '/images/platform-solid.png';

    images.platformMoving = new Image();
    images.platformMoving.onload = checkAllLoaded;
    images.platformMoving.src = '/images/platform-moving.png';

    images.platformBreakable = new Image();
    images.platformBreakable.onload = checkAllLoaded;
    images.platformBreakable.src = '/images/platform-breakable.png';

    images.platformFragile = new Image();
    images.platformFragile.onload = checkAllLoaded;
    images.platformFragile.src = '/images/platform-fragile.png';

    // Menu logo image
    images.speckyLogo = new Image();
    images.speckyLogo.onload = checkAllLoaded;
    images.speckyLogo.src = '/images/specky-logo.png';

    // Space bear enemy image
images.spaceBear = new Image();
images.spaceBear.onload = checkAllLoaded;
images.spaceBear.src = '/images/space-bear.png';

// Spring image
images.spring = new Image();
images.spring.onload = checkAllLoaded;
images.spring.src = '/images/spring.png';

// Slowmo boost image
images.boostSlowmo = new Image();
images.boostSlowmo.onload = checkAllLoaded;
images.boostSlowmo.src = '/images/slowmo.png';

// Magnet boost image
images.boostMagnet = new Image();
images.boostMagnet.onload = checkAllLoaded;
images.boostMagnet.src = '/images/magnet.png';

// Shield boost image
images.boostShield = new Image();
images.boostShield.onload = checkAllLoaded;
images.boostShield.src = '/images/shield.png';

// Shooter boost image
images.boostShooter = new Image();
images.boostShooter.onload = checkAllLoaded;
images.boostShooter.src = '/images/shooter.png';

// Double Points boost image
images.boostDoublePoints = new Image();
images.boostDoublePoints.onload = checkAllLoaded;
images.boostDoublePoints.src = '/images/doublepoints.png';

  });



};